import { Filter, RotateCcw, Search } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";

type FilterCardProps = {
  title: string;
  badge?: number;
  children: React.ReactNode;
  onFilter?: () => void;
  onReset?: () => void;
  showFilterButton?: boolean;
};

export function FilterCard({
  title,
  badge,
  children,
  onFilter,
  onReset,
  showFilterButton = true,
}: FilterCardProps) {
  const { t } = useTranslation();

  return (
    <div className="theme-card theme-card-static mb-6">
      <div className="flex items-center justify-between border-b border-border px-4 py-3.5 sm:px-5 sm:py-4">
        <div className="flex items-center gap-2">
          <Filter size={16} className="text-primary" />
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        </div>
        {badge !== undefined && (
          <span className="flex h-6 min-w-6 items-center justify-center rounded-md bg-purple-soft px-1.5 text-xs font-semibold text-purple">
            {badge}
          </span>
        )}
      </div>
      <div className="p-4 sm:p-5">{children}</div>
      {(showFilterButton || onReset) && (
      <div className="flex flex-col gap-2 border-t border-border px-4 py-4 sm:flex-row sm:items-center sm:px-5">
          {showFilterButton && (
            <button
              type="button"
              onClick={onFilter}
              className="flex w-full items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 sm:w-auto"
            >
              <Search size={16} />
              {t.safecheck.filter}
            </button>
          )}
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              className="flex w-full items-center justify-center gap-2 rounded-lg border border-border bg-card px-4 py-2.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-card-muted sm:w-auto"
            >
              <RotateCcw size={16} />
              {t.safecheck.reset}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
